import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaArrowLeft } from 'react-icons/fa';

const NotFound = () => {
  return (
    <div className="not-found">
      <div className="not-found-content">
        <h1 className="not-found-code">404</h1>
        <h2 className="not-found-title">Page Not Found</h2>
        <p className="not-found-message">
          Oops! The page you are looking for does not exist or has been moved.
        </p>
        <div className="not-found-buttons">
          <Link to="/" className="btn-primary">
            <FaHome /> Go Home
          </Link>
          <button type="button" onClick={() => window.history.back()} className="btn-secondary">
            <FaArrowLeft /> Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;